<mat-menu class="action-menu secret-profile-menu" [hasBackdrop]="true" #secretMenu="matMenu" xPosition="before">
  <ng-template matMenuContent>
    <div class="secret" (click)="$event.stopPropagation()" >
      <div class="save" >
        <button (click)="save(secretMenuTrigger)">Save</button>
        <button (click)="generateNotifications($event)">Generate notifications</button>
        <button (click)="showToast()">Show Toast</button>
        <button (click)="createAppMenu()">App Menu</button>
        <button (click)="killSession()">Kill Session</button>
        <button (click)="openErrorDialog()">Show Error Dialog</button>
        <button (click)="toggleSidenav()">Toggle sidenav view</button>
        @if (showSidenav) {
          <div>
            <label for="sidenav-state-select">Set sidenav state</label>
            <select id="sidenav-state-select" [(ngModel)]="activeMenuState" (change)="setSidenavMenuState()">
              @for (option of sidenavMenuStates; track option) {
                <option [ngValue]="option">{{option}}</option>
              }
            </select>
          </div>
        }
      </div>

      <span class="header">Update individual appIds:</span>
      <div class="overrides">

        @for (app of apps; track app) {
          <div class="override-apps">

            <!-- App name -->
            <div class="app-name">{{app}}</div>

            <!-- Override URL -->
            <div class="app-url">
              <input class="searchbox" type="text"
                [value]="getAppUrl(app)"
                (input)="updateUrl(app, $event)"
              >
            </div>

            <!-- Hide app -->
            @if (getAppVal(app)) {
              <div class="hide">
                Hide?:
                <input type="checkbox" id="{{getAppKey(app)}}-hidden" placeholder="Hide application {{app}}..."
                    [(ngModel)]="getAppVal(app).hidden"
                />
              </div>
            }
          </div>
        }

        <!-- Use Fake Grants? -->
        <div class="fakeGrants">
          Use Fake Grants?
          <input type="checkbox" [(ngModel)]="useFakeGrants" />
        </div>

        <!-- Clear AASP? -->
        <div class="fakeGrants">
          Clear and go to AASP Site Picker?
          <input type="checkbox" [(ngModel)]="clearAndReload"/>
        </div>

        <!-- Preserve iframes? -->
        <div class="fakeGrants">
          Preserve iframes?:
          <input type="checkbox" [(ngModel)]="preserveIframes"/>
        </div>

        <!-- Show CLM? -->
        <div class="fakeGrants">
          Show CLM?:
          <input type="checkbox" [(ngModel)]="showClm"/>
        </div>

        <!-- Enable PortalJs debug messages? -->
        <div class="fakeGrants">
          Enable debugging?:
          <input type="checkbox" [(ngModel)]="enableDebug"/>
        </div>

        <!-- Enable PortalJs debug messages? -->
        <div class="fakeGrants">
          Fully Disable UNv2?:
          <input type="checkbox" [(ngModel)]="disableUnV2"/>
        </div>

      </div>
    </div>
  </ng-template>
</mat-menu>

<button mat-menu-item  id="secret-menu-button" [matMenuTriggerFor]="secretMenu" #secretMenuTrigger="matMenuTrigger" aria-label="Secrets">
  <mat-icon [svgIcon]="icons.SECRET"></mat-icon>
</button>


